import app from "app.controller"


app.language.changed.add( () => {
  $fetch.clear()
})

let memory = new Map()

function $fetch(url, opts) {
  let hash = url
  if (opts.body) hash = hash + JSON.stringify(opts.body)
  let p = memory.get(hash)
  if (!p) {
    p = fetch(url, opts)
      .then(res => res.json())
      .catch(err => console.log("err", err))
    memory.set(hash, p)
  }
  return p
}

$fetch.clear = function () {
  memory = new Map()
}

$fetch.clear()

export default $fetch



// WEBPACK FOOTER //
// ./src/sdk/$fetch.js